import { html, TemplateResult } from 'lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-graphs-countries.css.lit';

interface BarItemList {
  graphText: string;
  graphNumber: number;
  barWidth: number;
}

interface BreakdownObj {
  tid: string;
  name: string;
  TOTAL: number;
  SUM: number;
}

interface SG1Obj {
  id: string;
  langcode: string;
  code: string;
  type: string;
  filter_a: string;
  filter_b: string;
  total_projects: number;
  total_amount: number;
  breakdown_a: BreakdownObj[];
}

interface jsonData {
  SG1: SG1Obj;
}

/**The IDB Graphs Countries component.
 * @element idb-graphs-countries
 */
@customElement('idb-graphs-countries')
export class IDBGraphsCountries extends OutlineElement {
  static styles = [componentStyles];

  /**
   * The title.
   */
  @property({ type: String, attribute: 'graphs-title' })
  graphsTitle: string;

  /**
   * The sub title.
   */
  @property({ type: String, attribute: 'graphs-sub-title' })
  graphsSubTitle: string;

  /**
   * Data coming from the API.
   */
  @property({ type: Object, attribute: 'data-list' })
  dataList: jsonData;

  /**
   * Data formatted for the title.
   */
  @property({ type: Object })
  stats: object;

  /**
   * Data list for bars
   */
  @property({ type: Array })
  barItemList: BarItemList[];

  connectedCallback() {
    super.connectedCallback();
    this.setData();
  }

  constructor() {
    super();
    this.barItemList = [];
    this.stats = [];
  }

  render(): TemplateResult {
    return html`
      <div class="idb-graphs-countries">
        <div class="idb-graphs-countries--header">
          <idb-heading level="h2" level-size="xl" level-style="semibold" capital-style='uppercase'>
            ${this.graphsTitle}
          </idb-heading>
        </div>
        <idb-stat-bar 
          component-color="blue-white" 
          style="small"
          stats=${JSON.stringify(this.stats)}
        >
        </idb-stat-bar>

        <idb-bar-graphs
          item-list=${JSON.stringify(this.barItemList)}
        >
        </idb-bar-graphs>
      </div>
    `;
  }

  setData = () => {
    const total_amount: number = this.dataList.SG1?.total_amount ?? 0;
    const totalApproved = `$ ${total_amount.toFixed(2)}M`;
    this.stats = [
      {
        stat: totalApproved,
        desc: this.graphsSubTitle,
      },
    ];

    for (const [, value] of Object.entries(
      this.dataList['SG1']['breakdown_a']
    )) {
      const total: number =
        this.dataList['SG1']['breakdown_a'][0]['TOTAL'] ?? 1;
      const barWidth: number = (value.TOTAL * 100) / total;
      this.barItemList.push({
        graphText: value.name,
        graphNumber: value.TOTAL,
        barWidth: barWidth,
      });
    }

    this.requestUpdate();
  };
}
